import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	emailInValid:{
		'id': 'login.emailInValid',
		'defaultMessage': 'The input is not valid E-mail!',
	},
	email:{
		'id': 'login.email',
		'defaultMessage': 'Please input your E-mail!',
	},
	placeholder:{
		'id': 'login.placeholder',
		'defaultMessage': 'Enter your email',
	},
	password:{
		'id': 'login.password',
		'defaultMessage': 'Please input your password!',
	},
	passwordPlaceholder:{
		'id': 'login.password.placeholder',
		'defaultMessage': 'Enter your password',
	},
});





// WEBPACK FOOTER //
// ./src/components/LogIn/messages.js